module.exports = __webpack_public_path__ + "img/426.bf0552ef.jpg";